import React from 'react';
import { Spinner } from 'reactstrap';
import investTechLogo from 'assets/images/logoBlueFull.svg'; // Logo for loader
import './Spinner.scss';

const LogoLoader = ({ backdrop }) => (
  <>
    <div className="spinner-container">
      <div className="spinner-card">
        <img className="spinner-body mogulIn" src={investTechLogo} alt="logo" />
        <Spinner className="spinner-body spin-content" />
      </div>
    </div>
    {backdrop && <div className="modal-backdrop show" />}
  </>
);

export default LogoLoader;
